import React, { useState, useEffect } from "react";
import styled from "styled-components";
import LatencyAndDistribution from "./LatencyAndDistribution";
import LatencyAndTimeEvolution from "./LatencyAndTimeEvolution";

const LatenciesLayout = styled.div`
  display: flex;
  flex-direction: column;
  h4 {
    margin-top: 30px;
  }
  & .message {
    flex: 1 1 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    min-height: 4cm;
  }
  .no-data {
    font-size: 18px;
    font-family: AllianceNo2-SemiBold !important;
  }
  .align-right {
    float: right;
  }
`;

const MainResult = ({ latencies, ...context }) => {
  if (!latencies) return null;
  return (
    <LatenciesLayout>
      {latencies.length === 0 ? (
        <div className="message">
          <span className="no-data">No latency records</span>
        </div>
      ) : (
        <>
          <LatencyAndDistribution {...context} latencies={latencies} />
          <LatencyAndTimeEvolution {...context} latencies={latencies} />
        </>
      )}
    </LatenciesLayout>
  );
};

export default MainResult;
